<template>
  <div class="header-container" :style="{ background: theme == 'white' ? '#F8F8F800' : '#F8F8F8' }">
    <img src="@/assets/logo.png" width="134" height="46" style="cursor: pointer;" @click="routerPush('/')">
    <div class="tabs-wrap">
      <div :class="['tab-item',]" :style="{ color: theme == 'white' ? '#ffffff' : '#333333' }"
        @click="tabClick(1), routerPush('/')">首页</div>
      <el-dropdown class="dropdown" :hide-on-click="false" placement="bottom" @command="(command) => {
        dropdownCommand(command)
        tabClick(2)
      }">
        <div :class="['tab-item', tabIndex == 2 ? 'tab-active' : '']"
          :style="{ color: theme == 'white' ? '#ffffff' : '#333333' }"> 产品中心</div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="intelligentEquipment">
            <span style="font-size: 18px;"
              :style="{ color: $route.name == 'intelligentEquipment' ? '#FF6A00' : '#333333' }">
              智能装备
            </span>
          </el-dropdown-item>
          <el-dropdown-item command="lowAltitudeApp">
            <span style="font-size: 18px;"
              :style="{ color: $route.name == 'lowAltitudeApp' ? '#FF6A00' : '#333333' }">低空应用</span></el-dropdown-item>
          <el-dropdown-item command="algorithmModel"><span style="font-size: 18px;"
              :style="{ color: $route.name == 'algorithmModel' ? '#FF6A00' : '#333333' }">算法模型</span></el-dropdown-item>
          <el-dropdown-item command="softwareSystem"><span style="font-size: 18px;"
              :style="{ color: $route.name == 'softwareSystem' ? '#FF6A00' : '#333333' }">软件系统</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="dropdown" :hide-on-click="false" placement="bottom" @command="(command) => {
        dropdownCommand(command)
        tabClick(3)
      }">
        <div :class="['tab-item', tabIndex == 3 ? 'tab-active' : '']"
          :style="{ color: theme == 'white' ? '#ffffff' : '#333333' }">解决方案</div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="jyysjskjdsjypfa"><span style="font-size: 18px;"
              :style="{ color: $route.name == 'jyysjskjdsjypfa' ? '#FF6A00' : '#333333' }">基于隐私计算框架的数据研判方案</span></el-dropdown-item>
          <el-dropdown-item command="kgkacrjaqjjfa"><span style="font-size: 18px;"
              :style="{ color: $route.name == 'kgkacrjaqjjfa' ? '#FF6A00' : '#333333' }">空港口岸出入境安全解决方案</span></el-dropdown-item>
          <el-dropdown-item command="hgkacrjaqjjfa"><span style="font-size: 18px;"
              :style="{ color: $route.name == 'hgkacrjaqjjfa' ? '#FF6A00' : '#333333' }">海港口岸出入境安全解决方案</span></el-dropdown-item>
          <el-dropdown-item command="jygyhlwsbsjdlhtzypfa" style="font-size: 18px;"
            :style="{ color: $route.name == 'jygyhlwsbsjdlhtzypfa' ? '#FF6A00' : '#333333' }"><span>基于工业互联网设备数据的量化特征研判方案</span></el-dropdown-item>
          <el-dropdown-item command="jyhlwgksjdlhtzypfa" style="font-size: 18px;"
            :style="{ color: $route.name == 'jyhlwgksjdlhtzypfa' ? '#FF6A00' : '#333333' }"><span>基于互联网公开数据的量化特征研判方案</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div :class="['tab-item', tabIndex == 4 ? 'tab-active' : '']"
        :style="{ color: theme == 'white' ? '#ffffff' : '#333333' }" @click="tabClick(4), routerPush('coreResearch')">
        核心研究
      </div>
      <div :class="['tab-item', tabIndex == 5 ? 'tab-active' : '']"
        :style="{ color: theme == 'white' ? '#ffffff' : '#333333' }" @click="tabClick(5), routerPush('ventureCapital')">
        创业投资</div>
      <div :class="['tab-item', tabIndex == 6 ? 'tab-active' : '']"
        :style="{ color: theme == 'white' ? '#ffffff' : '#333333' }" @click="tabClick(6), routerPush('about')">关于觉加
      </div>

      <el-popover popper-class="qr-popper-class" placement="bottom" width="100" trigger="hover">
        <el-image style="width: 100px;height: 100px;" :src="qrCode" fit="cover" :preview-src-list="[qrCode]"></el-image>
        <div :class="['tab-item',]" slot="reference">
          <svg-icon icon-class="ic_we_chat"
            :style="{ width: '20px', height: '20px', fill: theme == 'white' ? '#ffffff' : '#333333', cursor: 'pointer' }" />
        </div>
      </el-popover>

    </div>
  </div>
</template>

<script>

export default {
  props: {
    theme: {// 主题  主要是以字体颜色为主  white  black
      type: String,
      default: 'white'
    }
  },
  data () {
    return {
      tabIndex: 0,
      qrCode: require('@/assets/公司二维码.jpg')
    }
  },
  watch: {
    '$route.name' (n, o) {
      switch (n) {
        case 'intelligentEquipment':
        case 'lowAltitudeApp':
        case 'algorithmModel':
        case 'softwareSystem':
          this.tabIndex = 2
          break
        case 'hgkacrjaqjjfa':
        case 'jygyhlwsbsjdlhtzypfa':
        case 'jyhlwgksjdlhtzypfa':
        case 'kgkacrjaqjjfa':
        case 'jyysjskjdsjypfa':
          this.tabIndex = 3
          break
        case 'coreResearch':
          this.tabIndex = 4
          break
        case 'ventureCapital':
          this.tabIndex = 5
          break
        case 'about':
          this.tabIndex = 6
          break

        default:
          this.tabIndex = 1
          break
      }
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      })
    }
  },
  mounted () {

  },
  methods: {
    tabClick (index) {
      this.tabIndex = index
    },
    routerPush (name) {
      this.$router.push(name)
    },
    dropdownCommand (command) {
      this.routerPush(command)
    }
  }

}
</script>

<style lang="scss" scoped>
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 38px;
  padding-right: 30px;
  box-sizing: border-box;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    transform: translateX(-50%);
    transition: all 1s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  }

  &:hover::after {
    width: 100%;
    height: 1px;
  }

  .tabs-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    min-width: 752px;
    overflow: auto;

    .dropdown {}

    .tab-item {
      cursor: pointer;
      margin-right: 28px;
      margin-left: 28px;
      font-size: 18px;
      height: 100%;
      line-height: 100px;

      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 3px;
        background: #FF6A00;
        transform: translateX(-50%);
        transition: all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55);
      }

      &:hover::after {
        width: 100%;
        height: 5px;
      }
    }

    .tab-active {
      &::after {
        width: 100%;
        height: 0px;
      }
    }

  }
}
</style>
<style>
.el-dropdown-menu {
  padding: 20px 0;
}

.el-popper[x-placement^=bottom] {
  margin-top: 0;
  border-radius: 0;
}

.el-popper[x-placement^=bottom] .popper__arrow {
  display: none;
}

.el-dropdown-menu__item {
  padding: 0 28px;
  font-size: 16px;
  line-height: 44px;
}

.qr-popper-class {
  padding: 0 !important;
  min-width: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/headerView/index.vue